/**
 * Enum for the different type colors outside of theme color
 *
 * @enum
 */
export enum AlternateTypeColors {
  GRAY = 'rgb(51, 51, 51)',
  WHITE = 'rgb(255, 255, 255)'
}
